module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['wrapper', _vm.hasTopBorder && 'top-border'],
    style: (_vm._px2rem(_vm.newTabBarStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.mutilTabGroups.length > 0) ? _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "mutil-tab-bar-container weex-ct weex-div",
    style: (_vm._px2rem(_vm.mutilTabBarContainerStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.mutilTabGroups), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: " weex-ct weex-div",
      class: ['mutil-tab-bar-item', item.disabled && 'tab-bar-item-disabled'],
      attrs: {
        "weex-type": "div"
      }
    }, [(!item.launchText) ? _c('div', {
      staticClass: "mutil-icon-wrapper weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [(item.hasDot === true) ? _c('div', {
      staticClass: "dot-triangle weex-ct weex-div",
      style: ({
        backgroundColor: item.iconColor
      }),
      attrs: {
        "weex-type": "div"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "icon-container weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      ref: ("animate-circle-" + index),
      refInFor: true,
      staticClass: "animate-circle weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      ref: ("animate-circle-bg-" + index),
      refInFor: true,
      staticClass: "icon-inner-container weex-ct weex-div",
      style: ({
        backgroundColor: item.iconColor
      }),
      attrs: {
        "weex-type": "div",
        "data-evt-click": "",
        "data-evt-touchstart": "",
        "data-evt-touchend": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "touchstart": function($event) {
          $event.stopPropagation();
          return _vm.shrinkCircleFn(item, index, _vm.tabGroups)
        },
        "touchend": function($event) {
          $event.stopPropagation();
          return _vm.expandCircleFn(item, index, _vm.tabGroups)
        },
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.tabBarItemClicked(item, index, _vm.tabGroups)
        }
      }
    }, [(item.loading) ? _c('dof-spinner', {
      staticClass: "tab-bar-item-loading",
      attrs: {
        "type": _vm.resolveLoadingIcon(item.iconColor)
      }
    }) : (item.icon) ? _c('figure', {
      staticClass: "tab-bar-item-icon weex-el weex-image",
      attrs: {
        "src": item.icon,
        "data-img-src": item.icon,
        "weex-type": "image"
      }
    }) : (item.iconfont) ? _c('dof-iconfont', {
      attrs: {
        "code": item.iconfont,
        "size": item.iconfontSize || 96,
        "color": item.iconfontColor || 'rgba(255,255,255, 0.4)'
      }
    }) : (item.iconText) ? _c('p', {
      staticClass: "tab-bar-item-icon-text weex-el weex-text",
      style: ({
        color: !!item.iconTextColor ? item.iconTextColor : _vm._iconTextColor
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.iconText))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (item.launchText) ? _c('div', {
      staticClass: "is-launch weex-ct weex-div",
      style: ({
        backgroundColor: item.launchBg,
        width: _vm._px2rem(item.launchWidth, 75)
      }),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: "is-launch-text weex-el weex-text",
      style: ({
        color: item.launchColor
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.launchText))])]) : _vm._e()])
  }), 0)], {})], 2) : _c('div', {
    staticClass: "tab-bar-container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "tab-bar-list weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", _vm._l((_vm.tabGroups), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: " weex-ct weex-div",
      class: ['tab-bar-item', item.disabled && 'tab-bar-item-disabled'],
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "icon-wrapper weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [(item.hasDot === true) ? _c('div', {
      staticClass: "dot-triangle weex-ct weex-div",
      style: ({
        backgroundColor: item.borderColor ? item.borderColor : item.iconColor ? item.iconColor : _vm._iconColor
      }),
      attrs: {
        "weex-type": "div"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "icon-container weex-ct weex-div",
      style: ({
        width: _vm._px2rem(_vm.widthCalcBig(item), 75)
      }),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      ref: ("animate-circle-" + index),
      refInFor: true,
      staticClass: "animate-circle weex-ct weex-div",
      style: ({
        width: _vm._px2rem(_vm.widthCalcSmall(item), 75)
      }),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      ref: ("animate-circle-bg-" + index),
      refInFor: true,
      staticClass: "icon-inner-container weex-ct weex-div",
      style: ({
        width: _vm._px2rem(_vm.widthCalc(item), 75),
        backgroundColor: _vm.handleBg(item),
        borderWidth: _vm._px2rem('2px', 75),
        borderColor: item.borderColor ? item.borderColor : item.iconColor ? item.iconColor : _vm._iconColor
      }),
      attrs: {
        "weex-type": "div",
        "data-evt-click": "",
        "data-evt-touchstart": "",
        "data-evt-touchend": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "touchstart": function($event) {
          $event.stopPropagation();
          return _vm.shrinkCircleFn(item, index, _vm.tabGroups)
        },
        "touchend": function($event) {
          $event.stopPropagation();
          return _vm.expandCircleFn(item, index, _vm.tabGroups)
        },
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.tabBarItemClicked(item, index, _vm.tabGroups)
        }
      }
    }, [(item.loading) ? _c('dof-spinner', {
      staticClass: "tab-bar-item-loading",
      attrs: {
        "type": _vm.resolveLoadingIcon(item.iconColor)
      }
    }) : (item.icon) ? _c('figure', {
      staticClass: "tab-bar-item-icon weex-el weex-image",
      attrs: {
        "src": item.icon,
        "data-img-src": item.icon,
        "weex-type": "image"
      }
    }) : (item.iconfont) ? _c('dof-iconfont', {
      attrs: {
        "code": item.iconfont,
        "size": item.iconfontSize || 96,
        "color": item.iconfontColor || 'rgb(102,102,102)'
      }
    }) : (item.iconText) ? _c('p', {
      staticClass: "tab-bar-item-icon-text weex-el weex-text",
      style: ({
        color: item.textColor ? item.textColor : _vm.handleIconTextColor(item)
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.iconText))]) : _vm._e()], 1), _vm._v(" "), (_vm._isColmo && !item.disabled && !item.loading) ? _c('div', {
      staticClass: "mask weex-ct weex-div",
      style: ({
        width: _vm._px2rem(_vm.widthCalc(item), 75)
      }),
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.tabBarItemClicked(item, index, _vm.tabGroups)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "tab-bar-item-title weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: "tab-bar-item-title-text weex-el weex-text",
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.text))])])])
  }), {})], 2)]), _vm._v(" "), (_vm.isIPhoneX) ? _c('div', {
    staticClass: "line-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bace8aa8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bace8aa8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-bottom-bar/index.vue
// module id = 664
// module chunks = 0 1